import styled from 'styled-components';

const HalfWidthFieldWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  > * {
    width: calc(50% - 8px);
  }
`;

export default HalfWidthFieldWrapper;
